import React from 'react';
import { Home, Clock, Eye, MessageSquare, Plus, MoreVertical } from 'lucide-react';
import { Link } from 'react-router-dom';
import { properties, formatNaira } from '../../data/mockData';
import { VerificationBadge, TierBadge } from '../../components/shared/Badges';
export const SellerDashboard = () => {
  const myProperties = properties.slice(0, 3);
  return <div className="space-y-8 animate-in fade-in" data-id="element-1499">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-1500">
        <div data-id="element-1501">
          <h1 className="text-2xl font-serif font-bold text-primary-900 mb-1" data-id="element-1502">
            Seller Dashboard
          </h1>
          <p className="text-text-light" data-id="element-1503">
            Manage your listings and track performance.
          </p>
        </div>
        <Link to="/list-property" className="bg-secondary hover:bg-secondary-dark text-white px-5 py-2.5 rounded-lg text-sm font-bold transition-colors shadow-glow flex items-center gap-2" data-id="element-1504">
          <Plus size={18} data-id="element-1505" /> New Listing
        </Link>
      </div>

      {/* Overview Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1506">
        {[{
        label: 'Active Listings',
        value: '3',
        icon: Home,
        color: 'text-success',
        bg: 'bg-success/10'
      }, {
        label: 'Pending Verification',
        value: '1',
        icon: Clock,
        color: 'text-secondary-dark',
        bg: 'bg-secondary/10'
      }, {
        label: 'Total Views',
        value: '1,248',
        icon: Eye,
        color: 'text-primary-600',
        bg: 'bg-primary-50'
      }, {
        label: 'New Inquiries',
        value: '12',
        icon: MessageSquare,
        color: 'text-neutral-dark',
        bg: 'bg-neutral-200'
      }].map((stat, i) => {
        const Icon = stat.icon;
        return <div key={i} className="bg-white p-5 rounded-2xl shadow-sm border border-neutral-200 flex items-center gap-4" data-id="element-1507">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${stat.bg} ${stat.color}`} data-id="element-1508">
                <Icon size={24} data-id="element-1509" />
              </div>
              <div data-id="element-1510">
                <div className="text-2xl font-bold text-text" data-id="element-1511">{stat.value}</div>
                <div className="text-xs font-bold text-text-light uppercase tracking-wider" data-id="element-1512">
                  {stat.label}
                </div>
              </div>
            </div>;
      })}
      </div>

      {/* Listings Table */}
      <div className="bg-white rounded-2xl shadow-sm border border-neutral-200 overflow-hidden" data-id="element-1513">
        <div className="p-6 border-b border-neutral-200 flex items-center justify-between" data-id="element-1514">
          <h2 className="text-lg font-serif font-bold text-primary-900" data-id="element-1515">
            My Properties
          </h2>
          <button className="text-sm font-bold text-text-light hover:text-text" data-id="element-1516">
            View All
          </button>
        </div>

        <div className="overflow-x-auto" data-id="element-1517">
          <table className="w-full text-left border-collapse" data-id="element-1518">
            <thead data-id="element-1519">
              <tr className="bg-neutral-50 text-xs font-bold text-text-light uppercase tracking-wider border-b border-neutral-200" data-id="element-1520">
                <th className="p-4 pl-6" data-id="element-1521">Property</th>
                <th className="p-4" data-id="element-1522">Status</th>
                <th className="p-4" data-id="element-1523">Tier</th>
                <th className="p-4" data-id="element-1524">Price</th>
                <th className="p-4" data-id="element-1525">Views</th>
                <th className="p-4 pr-6 text-right" data-id="element-1526">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-neutral-100" data-id="element-1527">
              {myProperties.map(p => <tr key={p.id} className="hover:bg-neutral-50 transition-colors" data-id="element-1528">
                  <td className="p-4 pl-6" data-id="element-1529">
                    <div className="flex items-center gap-3" data-id="element-1530">
                      <img src={p.images[0]} alt="" className="w-12 h-12 rounded-lg object-cover" data-id="element-1531" />
                      <div data-id="element-1532">
                        <div className="font-bold text-sm text-text line-clamp-1" data-id="element-1533">
                          {p.title}
                        </div>
                        <div className="text-xs text-text-light" data-id="element-1534">
                          {p.district}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="p-4" data-id="element-1535">
                    <VerificationBadge status={p.verificationStatus as any} data-id="element-1536" />
                  </td>
                  <td className="p-4" data-id="element-1537">
                    <TierBadge tier={p.tier as 1 | 2 | 3} data-id="element-1538" />
                  </td>
                  <td className="p-4 font-medium text-sm text-text" data-id="element-1539">
                    {formatNaira(p.price)}
                  </td>
                  <td className="p-4 text-sm text-text-light" data-id="element-1540">
                    {Math.floor(Math.random() * 500) + 100}
                  </td>
                  <td className="p-4 pr-6 text-right" data-id="element-1541">
                    <button className="p-2 text-text-light hover:text-text rounded-lg hover:bg-neutral-200 transition-colors" data-id="element-1542">
                      <MoreVertical size={18} data-id="element-1543" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};